<div id="cart">
  <div class="container main-container">
    <div class="main-body">
      <cart-items></cart-items>
      <cart-payment></cart-payment>
    </div>
  </div>
</div>